import x from "../../../assets/images/X.png";
import back from "../../../assets/images/back.png";

import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import Search1 from "../../../assets/images/Search1.png";
import Previous from "../../../assets/images/Previous.png";
import SubCategory from "../../../Json/SubCategory.json";
import brands from "../../../Json/Brand.json";

import { useLocation, useNavigate } from "react-router-dom";
import { SetSearch } from "../../../features/TopSearches/TopSearchesSlice";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import {
  SetSelectdPage,
  SetSizeFilter,
  SetTopSizeFilter,
  SortProducts,
} from "../../../features/Products/ProductSlice";
import NotificationModal from "../NotificationModal";

function SeacrhMenuBags({ show, setShow, id, setShowbefore, setShowfirst }) {
  const { i18n, t } = useTranslation();
  const { subtype } = useSelector((store) => store.topsearches);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sq, setsq] = useState("");

  let parametres = new URLSearchParams(useLocation().search);
  const designersSection = [
    {
      name: "Louis Vuitton",
    },
    {
      name: "Gucci",
    },
    {
      name: "Valentino Garavani",
    },
    {
      name: "Chanel",
    },
    {
      name: "Dior",
    },
    {
      name: "Prada",
    },
    {
      name: "Celine",
    },
    {
      name: "Bottega Veneta",
    },
    {
      name: "Saint Laurent",
    },
    {
      name: "Fendi",
    },
    {
      name: "Balenciaga",
    },
    {
      name: "Dolce & Gabanna",
    },
    {
      name: "Michael Kors",
    },
    {
      name: "Marc Jacobs",
    },
    {
      name: "Hermès",
    },
  ];
  const ModelSection = [
    {
      id: "The Birkin",
      name: "The Birkin",
      nameAr: "بيركين",
    },
    {
      id: "The Dionysus",
      name: "The Dionysus",
      nameAr: "ديونيسوس",
    },
    {
      id: "The Jackie 1961",
      name: "The Jackie 1961",
      nameAr: "جاكي ١٩٦١",
    },
    {
      id: "The Marmont",
      name: "The Marmont",
      nameAr: "مارمون",
    },
    {
      id: "The Neverfull",
      name: "The Neverfull",
      nameAr: "نيفيرفل",
    },
    {
      id: "The Pochette Accessoire",
      name: "The LV Pochette Accessoire",
      nameAr: "لويس فيتون بوشيت اكسسوار",
    },
    {
      id: "The Saddle",
      brand: "Dior",
      name: "The Dior Saddle ",
      nameAr: "ديور سادل",
    },
    {
      id: "The Speedy",
      name: "The LV Speedy",
      nameAr: "لويس فيتون سبيدي",
    },
    {
      id: "The Lady Dior",
      name: "The Lady Dior",
      nameAr: "لايدي ديور",
    },
    {
      brand: "Fendi",
      id: "The Baguette",
      name: "The Fendi Baguette",
      nameAr: "فندي باغيت",
    },
    {
      id: "The  Kelly",
      name: "The Kelly",
      nameAr: "كيلي",
    },
    {
      id: "The Boy",
      name: "The Boy Bag",
      nameAr: "شنطة بوي",
    },

    {
      id: "The Phantom",
      name: "The Phantom",
      nameAr: "شنطة بوي",
    },
    {
      id: "The City",
      name: "The City",
      nameAr: "سيتى",
    },

    {
      id: "The Sac De Jour",
      name: "The Sac Du Jour",
      nameAr: "ساك دو جور",
    },
    {
      id: "The Triomphe",
      name: "The Triomphe",
      nameAr: "تريومف",
    },
  ];
  return (
    <>
      <Modal show={show} fullscreen className="modal fade mx-0 px-0">
        <Modal.Body className="p-0 m-0 ">
          <div className="px-4 modal-header justify-content-between align-items-center d-flex pb-0">
            <div style={{ cursor: "pointer" }}>
              <button
                type="button"
                className="close close-txt close-modal align-items-center px-0"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setShow(false)}
              >
                <img
                  alt="main"
                  src={back}
                  onClick={() => setShow(false)}
                  className={` ${
                    i18n.language == "en" ? "Previous" : "PreviousAr"
                  }`}
                />
              </button>
            </div>
            <button
              type="button"
              className="close close-txt close-modal align-items-center px-0"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => setShow(false)}
            >
              <img
                src={x}
                alt="main"
                onClick={() => setShow(false)}
                className="x-close  mb-1"
              />
            </button>
          </div>

          <div className="modal-body px-4">
            {subtype == "Designers" && (
              <>
                <div
                  className="w-100 pt-2 pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenutitle"
                    style={{ textTransform: "uppercase" }}
                    onClick={() =>
                      navigate("/brands") & dispatch(SortProducts("")) &&
                      setShow(false) &
                        setShowbefore(false) &
                        setShowfirst(false)
                    }
                  >
                    {t("Designers")}
                  </div>
                </div>

                {designersSection.map((brandsection) =>
                  brands
                    .filter((brand) => brand.name == brandsection.name)
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((sub) => (
                      <>
                        <div
                          className="searchmenunew pb-4"
                          onClick={() =>
                            setShow(false) &
                            setShowbefore(false) &
                            setShowfirst(false)
                          }
                        >
                          <div
                            onClick={() =>
                              navigate(
                                `/products?id=AqFLulu9y2m4mqEIkch1&brand=${sub.id}`
                              )
                            }
                            className="searchmenunew "
                          >
                            {i18n.language == "en" ? sub.name : sub.nameAr}
                          </div>
                        </div>
                      </>
                    ))
                )}
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                >
                  <div
                    className="searchmenunew"
                    style={{ fontFamily: "Montserrat-SemiB" }}
                    onClick={() =>
                      navigate("/brands") &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("View All Brands")}
                  </div>
                </div>
              </>
            )}

            {subtype == "Timeless Models" && (
              <>
                <div
                  className="w-100 pt-2 pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenutitle"
                    style={{ textTransform: "uppercase" }}
                    onClick={() =>
                      navigate("/products?id=AqFLulu9y2m4mqEIkch1") &
                        dispatch(SortProducts("")) &&
                      setShow(false) &
                        setShowbefore(false) &
                        setShowfirst(false)
                    }
                  >
                    {t("Timeless Models")}
                  </div>
                </div>

                {ModelSection.map((sub) => (
                  <div
                    className="searchmenunew pb-4"
                    onClick={() =>
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    <div
                      onClick={() =>
                        navigate(
                          `/products?id=AqFLulu9y2m4mqEIkch1&model=${sub.id.toLowerCase()}${
                            sub.brand ? `&nameBrand=${sub.brand}` : ``
                          }`
                        )
                      }
                      className="searchmenunew "
                    >
                      {i18n.language == "en" ? sub.name : sub.nameAr}
                    </div>
                  </div>
                ))}
              </>
            )}

            {subtype == "Women" && (
              <>
                <div
                  className="w-100 pt-2 pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenutitle"
                    style={{ textTransform: "uppercase" }}
                    onClick={() =>
                      navigate(
                        "/products?id=AqFLulu9y2m4mqEIkch1&gender=WFA967se7qX0jYtySgTj"
                      ) & dispatch(SortProducts("")) &&
                      setShow(false) &
                        setShowbefore(false) &
                        setShowfirst(false)
                    }
                  >
                    {t("Women")}
                  </div>
                </div>

                {SubCategory.filter(
                  (subcat) => subcat.idTypeCategory == "AqFLulu9y2m4mqEIkch1"
                )
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((sub) => (
                    <div
                      className="searchmenunew pb-4"
                      onClick={() =>
                        setShow(false) &
                        setShowbefore(false) &
                        setShowfirst(false)
                      }
                    >
                      <div
                        onClick={() =>
                          navigate(
                            `/products?id=AqFLulu9y2m4mqEIkch1&subcategory=${sub.id}&gender=WFA967se7qX0jYtySgTj`
                          )
                        }
                        className="searchmenunew "
                      >
                        {i18n.language == "en" ? sub.name : sub.nameAr}
                      </div>
                    </div>
                  ))}
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    style={{ fontFamily: "Montserrat-SemiB" }}
                    onClick={() =>
                      navigate(
                        "/products?id=AqFLulu9y2m4mqEIkch1&gender=WFA967se7qX0jYtySgTj&"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("View All Women Bags")}
                  </div>
                </div>
              </>
            )}
            {subtype == "Men" && (
              <>
                <div
                  className="w-100 pt-2 pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenutitle"
                    style={{ textTransform: "uppercase" }}
                    onClick={() =>
                      navigate(
                        "/products?id=AqFLulu9y2m4mqEIkch1&gender=KG3s4pPk3arcBux5ERnD"
                      ) & dispatch(SortProducts("")) &&
                      setShow(false) &
                        setShowbefore(false) &
                        setShowfirst(false)
                    }
                  >
                    {t("Men")}
                  </div>
                </div>

                {SubCategory.filter(
                  (subcat) =>
                    subcat.idTypeCategory == "AqFLulu9y2m4mqEIkch1" &&
                    (subcat.id == "tjVkKS7xYRxBJKXdB1hI" ||
                      subcat.id == "vQu1MYpVFAxIgsrDYpd9")
                )
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((sub) => (
                    <div
                      className="searchmenunew pb-4"
                      onClick={() =>
                        setShow(false) &
                        setShowbefore(false) &
                        setShowfirst(false)
                      }
                    >
                      <div
                        onClick={() =>
                          navigate(
                            `/products?id=AqFLulu9y2m4mqEIkch1&subcategory=${sub.id}&gender=KG3s4pPk3arcBux5ERnD`
                          )
                        }
                        className="searchmenunew "
                      >
                        {i18n.language == "en" ? sub.name : sub.nameAr}
                      </div>
                    </div>
                  ))}
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                >
                  <div
                    className="searchmenunew"
                    style={{ fontFamily: "Montserrat-SemiB" }}
                    onClick={() =>
                      navigate(
                        "/products?id=AqFLulu9y2m4mqEIkch1&gender=KG3s4pPk3arcBux5ERnD&"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("View All Men Bags")}
                  </div>
                </div>
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SeacrhMenuBags;
